import placeholder from 'res/placeholder.png';

export const PLACEHOLDER_URL = placeholder;

export const MOBILE_QUERY = { maxWidth: 600 };
